<template>
  <div class="">
    <div class="pc d-none d-lg-block">
      <div class="container banner_content">
        <dl class="text_zh">
          <img class="praise" src="~assets/img/home/praise.png" alt="" srcset="" />
          <dt>加入我们</dt>
          <dd>和世界一流的WebRTC工程师团队并肩打造新一代视频原生的企业信息化基础设施</dd>
        </dl>
        <div class="league">
          <Carousel class="img-box" loop autoplay>
            <CarouselItem v-for="(item, index) in imgList" :key="index">
              <div class="carousel">
                <img class="carousel-img" :src="item.url" alt="" srcset="" />
              </div>
            </CarouselItem>
          </Carousel>
        </div>
      </div>
    </div>
    <div class="mobile d-lg-none">
      <div class="container banner_content">
        <dl class="text_zh">
          <dt>加入我们</dt>
          <dd>
            和世界一流的WebRTC工程师团队并肩打造
            <br />
            新一代视频原生的企业信息化基础设施
          </dd>
        </dl>
        <div class="league">
          <Carousel class="img-box" loop autoplay>
            <CarouselItem v-for="(item, index) in imgList" :key="index">
              <div class="carousel">
                <img class="carousel-img" :src="item.url" alt="" srcset="" />
              </div>
            </CarouselItem>
          </Carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "JoinBanner",
    data() {
      return {
        imgList: [
          {
            // url: "https://zealcomm-site-assets.zealcomm.cn/ajuiopaf0u0q123.JPG",
            url: "https://zealcomm-site-assets.zealcomm.cn/ajuiopaf0u0q123.JPG?x-oss-process=image/resize,w_1246",
          },
          {
            url: "https://zealcomm-site-assets.zealcomm.cn/bjasduoq09u10ds.jpg?x-oss-process=image/resize,w_1246",
          },
          {
            url: "https://zealcomm-site-assets.zealcomm.cn/cp98aho123e80af.jpg?x-oss-process=image/resize,w_1246",
          },
          {
            url: "https://zealcomm-site-assets.zealcomm.cn/d90joeriojvfljk.jpg?x-oss-process=image/resize,w_1246",
          },
          {
            url: "https://zealcomm-site-assets.zealcomm.cn/er09urjiogjzsjd.jpg?x-oss-process=image/resize,w_1246",
          },
          {
            url: "https://zealcomm-site-assets.zealcomm.cn/f09uhiawe09uwei.jpg?x-oss-process=image/resize,w_1246",
          },
          {
            url: "https://zealcomm-site-assets.zealcomm.cn/gp09jopu8jzvpu8.jpg?x-oss-process=image/resize,w_1246",
          },
        ],
      };
    },
  };
</script>

<style lang="scss" scoped>
  %imgVar {
    .img-box {
      position: absolute;
      width: 100%;
      height: 100%;

      ::v-deep .ivu-carousel-list {
        height: 100%;
      }

      ::v-deep .ivu-carousel-track {
        height: 100%;
      }

      ::v-deep .ivu-carousel-item {
        height: 100% !important;
      }

      .carousel {
        height: 100%;

        img.carousel-img {
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }
      }
    }
  }

  %dots {
    ::v-deep .ivu-carousel-dots {
      li {
        button {
          background: #fff;
          opacity: 1;
        }
      }

      li.ivu-carousel-active {
        > button {
          background: $main-color;
        }
      }
    }
  }

  .pc {
    overflow: hidden;
    background: #edfdf8;

    .banner_content {
      margin-top: 85px;
      margin-bottom: 85px;

      @extend .flex-space-between;

      .text_zh {
        .praise {
          margin-left: -16px;
          width: 84px;
        }

        dt {
          color: #333;
          font-size: 48px;
          font-weight: bold;
        }

        dd {
          margin-top: 36px;
          max-width: 459px;
          color: #666;
          font-size: 24px;
        }
      }

      .league {
        @extend %dots;
        // position: relative;
        // flex: 1;
        // margin-left: 107px;
        // padding-bottom: 39%;
        // width: 470px;
        // height: 310px;

        // @extend %imgVar;
        .img-box {
          // position: absolute;
          // width: 100%;
          // height: 100%;
          width: 470px;

          ::v-deep .ivu-carousel-list {
            // height: 100%;
          }

          ::v-deep .ivu-carousel-track {
            // height: 100%;
          }

          ::v-deep .ivu-carousel-item {
            // height: 100% !important;
          }

          .carousel {
            // height: 100%;

            img.carousel-img {
              // width: 100%;
              // height: 100%;
              // width: 470px;
              height: 310px;
              border-radius: 10px;
            }
          }
        }
      }
    }
  }

  .mobile {
    .text_zh {
      margin: 17% 0 8%;
      text-align: center;

      dt {
        color: #333;
        font-size: 22px;
        font-weight: bold;
      }

      dd {
        margin-top: 15px;
        color: #666;
        font-size: 14px;
      }
    }

    .league {
      position: relative;
      padding-bottom: 64%;
      @extend %dots;
      @extend %imgVar;
    }
  }
</style>
